import React from 'react';
import Transition from 'react-transition-group/Transition';

const duration = 500;
const transitionStyles = {
  entering: { display: 'none' },
  entered: { display: 'block' },
};

type Props = {
  stroke?: string,
  radius?: number,
  percent?: number,
  strokeWidth?: number,
};

const Circle = ({
  radius,
  percent,
  stroke,
  strokeWidth,
}: Props) => {
  const normalizedRadius = radius - strokeWidth + 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percent / 100) * circumference;

  return (
    <Transition
      in={percent !== 100}
      timeout={duration}
      unmountOnExit
    >
      {state => (
        <svg
          width={radius * 2}
          height={radius * 2}
          style={{
            ...transitionStyles[state],
          }}
        >
          <circle
            fill="transparent"
            stroke={stroke}
            strokeDasharray={`${circumference} ${circumference}`}
            strokeWidth={strokeWidth}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            style={{
              strokeDashoffset,
              transition: `all ${duration}ms`,
              transform: 'rotate(-90deg)',
              transformOrigin: '50% 50%',
            }}
          />
        </svg>
      )}
    </Transition>
  );
};

Circle.defaultProps = {
  radius: 70,
  percent: 0,
  stroke: 'white',
  strokeWidth: 3,
};

export default Circle;
